import { Component, OnInit,ViewChild,ElementRef } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';

import { ApiLoginService } from '@app/api/api-login.service';
import { ApiContentService } from '@app/api/api-content.service';
import { ApiPartnerService } from '@app/api/api-partner.service';
import { LoadJsService } from '../../load-js/load-js.service';
import { AuthenticationService } from '../../_services/authentication.service';


@Component({
  selector: 'app-requestrelease',
  templateUrl: './requestrelease.component.html',
  styleUrls: ['./releasestb.component.css']
})
export class RequestreleaseComponent implements OnInit {
  @ViewChild("fileUploader", { static: false })
  fileUploader: ElementRef;
  constructor(
    public restApi:ApiPartnerService,
    private fb: FormBuilder,
    private login: ApiLoginService,
    public partnerService: ApiPartnerService,
    public LoadJsOrder: LoadJsService,
    private router: Router, 
    private Auth: AuthenticationService,
  ) { }

  formRequest = this.fb.group({
    partnerid : [''],
    //partnername: [''],
    pic : [''],
    note: [''],
  });

  btn_save = true
  btn_loading = false
  alert_failed = false
  alert_success = false
  alert_redirect = false
  alert_quota = false
  table_product_kosong = true
  table_product_data = false
  
  permision : string[] = [];
  currentuser : any = {};

  selectedProduct: any = []
  data_table_product: any = []
  data_partner:any=[];
  data_product:any={}
  partnerlogin:any={}
  response_api:any={}

  count:number = 0
  sum:number = 0

  ordertypeValue=''

  ngOnInit() {
    this.currentuser = this.Auth.currentUserValue;
    console.log(this.currentuser);
    this.permision = this.currentuser.permision;
    this.loadStart();
  }

  loadStart(){
    this.LoadJsOrder.loadScriptOrderService()
    if ( this.MyPermission('_FULLRELEASESTB') ) {
      this.partner();
    }else{
      this.getpartnerlogin();
    }
  }

  partner() {
    this.restApi.GetViewpartnerless().subscribe((output: any) => { 
      this.data_partner = output.data
    });  
  }

  refreshPage() {
    this.ngOnInit()
  }

  getpartnerlogin(){
    return this.restApi.Partnerfromlogin().subscribe((output: any) => {
      this.partnerlogin = output
      console.log(this.partnerlogin);

      this.formRequest.get('partnerid').setValue(this.partnerlogin.partnerid);
      //this.formRequest.get('partnername').setValue(this.partnerlogin.partnername);

      this.data_partner=[{id:this.partnerlogin.partnerid,partnername:this.partnerlogin.partnername}];

    })
  }

  redirectListorder(params: any) {
    this.router.navigate([params]);
  }

  save() {

    const data = 
    
    {
      "partnerid" : this.formRequest.get('partnerid').value,
      "pic" : this.formRequest.get('pic').value,
      "note" : this.formRequest.get('note').value,
    }

    console.log(data);
    this.restApi.PostReqreleasestb(data)
      .subscribe((output: any) => { 
        console.log(output)
        this.response_api = output.data
        if (output.status) {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_success = true
  
          this.alert_redirect = true
          setTimeout(()=>{
            this.redirectListorder("releasestb/view/"+this.response_api.id);
          }, 5000);
        } else {

          this.LoadJsOrder.loadScriptProductStb()
          this.alert_failed = true
          setTimeout(()=>{
            this.alert_failed = false
          }, 6000);
        }
      }
    );
  }

  MyPermission(p)
  {
    if ( this.permision == undefined ){
      return false;
    }
    
    if (this.permision.indexOf(p) > -1){
      return true;
    }else{
        return false;
    }

  }

}
